export default {"src":"/_next/static/media/dao-small.39ee60ac.svg","height":250,"width":614,"blurWidth":0,"blurHeight":0};